module.exports = __webpack_public_path__ + "static/media/logo-block.410b744f.svg";